/** Leave the app for the identity provider (a seam so tests can observe it). */
export function redirectTo(url: string): void {
  window.location.assign(url);
}
